import { useEffect, useMemo, useState } from "react";
import { PaymentSchedule } from "../../../../../../types/bookings";
import { SelectOption } from "../../../../../../types/select";

export const usePreviewScheduleYearFilter = (paymentSchedule: PaymentSchedule[] = []) => {
  const yearOptions: SelectOption<number>[] = useMemo(() => {
    const years = Array.from(
      new Set(paymentSchedule.map((row) => row?.yearNumber).filter((year): year is number => typeof year === "number")),
    ).sort((a, b) => a - b);

    return years.map((year) => ({ label: `Year ${year}`, value: year }));
  }, [paymentSchedule]);

  const shouldEnableYearFilter = useMemo(
    () => yearOptions.length > 1 && yearOptions.some((item) => item.value > 1),
    [yearOptions],
  );

  const [selectedYear, setSelectedYear] = useState<number | undefined>();

  useEffect(() => {
    if (!shouldEnableYearFilter) {
      setSelectedYear(undefined);
      return;
    }

    const yearOne = yearOptions.find((item) => item.value === 1)?.value;
    setSelectedYear(yearOne ?? yearOptions[0].value);
  }, [shouldEnableYearFilter, yearOptions]);

  const filteredData = useMemo(() => {
    if (!shouldEnableYearFilter || selectedYear == null) return paymentSchedule;
    return paymentSchedule.filter((row) => row?.yearNumber === selectedYear);
  }, [paymentSchedule, selectedYear, shouldEnableYearFilter]);

  return {
    yearOptions,
    selectedYear,
    setSelectedYear,
    shouldEnableYearFilter,
    filteredData,
  };
};
